<script lang="ts">
    import type { Snippet } from 'svelte';
    import type { Deal, Price } from '@shared/types/types';
    import { parseGermanNumber, toCents } from './priceConversion.ts';

    interface Props {
        price: Price;
        deal?: Deal;
        variationId: string;
        rule?: string;
        showBenefitTag?: boolean;
        bestVariationBenefit?: string;
        children?: Snippet;
    }

    const { price, deal, variationId, rule, showBenefitTag = true, bestVariationBenefit, children }: Props = $props();
</script>

<div class="reptile-pricing-item">
    <ofc-pricing-item-v1
        retail-price={toCents(price.retailPrice)}
        old-price={toCents(price.sale ? price.comparativePrice : undefined)}
        suggested-retail-price={toCents(price.sale ? price.suggestedRetailPrice : undefined)}
        unit-price={toCents(price.normPrice?.value)}
        unit-price-amount={parseGermanNumber(price.normPrice?.amount)}
        unit-price-unit={price.normPrice?.unit}
        is-starting-price={price.isStartingPrice || undefined}
        deal-highlight={deal?.highlight}
        deal-id={deal?.dealId}
        display-alignment="left"
        display-size="100"
        meta-origin-feature="product-listing"
        meta-team="reptile"
    >
        <!--
            Server-rendered price information for crawlers (documented `seo` slot of
            ofc-pricing-item-v1); mirrors the texts the status-quo price rendering shows.
        -->
        <div slot="seo" class="reptile-pricing-item__seo">
            {#if deal?.highlight}
                <span>{deal.highlight}</span>
            {/if}
            <span>{price.isStartingPrice ? 'ab ' : ''}{price.retailPrice} €</span>
            {#if price.sale && price.suggestedRetailPrice}
                <span>UVP {price.suggestedRetailPrice} €</span>
            {:else if price.sale && price.comparativePrice}
                <span>{price.comparativePrice} €</span>
            {/if}
            {#if price.normPrice}
                <span>({price.normPrice.value} €/ {price.normPrice.amount} {price.normPrice.unit})</span>
            {/if}
        </div>
        {#if showBenefitTag && bestVariationBenefit}
            <ft9-benefit-tag-v1
                slot="benefit-tag"
                data-secondary-action
                id={`${variationId}-benefit-tag`}
                current-context-dreson={rule}
                team="reptile"
                feature="tilelist"
                data={bestVariationBenefit}
            ></ft9-benefit-tag-v1>
        {/if}
    </ofc-pricing-item-v1>
    {@render children?.()}
</div>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile-pricing-item {
        display: flex;
        flex-direction: column;
        gap: tokens.$oc-semantic-spacing-25;

        &__seo {
            /*                                                                      */
            /*                                                                 */
            display: none;
        }
    }
</style>
